import type {
  AlertColor,
  AlertKind,
  QueuedAlert,
} from '../store/alertQueueSlice';
// Note: We only build alerts here; dispatching is done by callers via alertQueueActions

interface EnqueueParams {
  id?: string; // if omitted, generated internally
  title: string;
  description: string;
  colorTheme?: AlertColor;
  kind?: AlertKind;
  autoDismissDelay?: number;
}

const defaultColor: AlertColor = 'Information';
const defaultKind: AlertKind = 'low';

const genId = () =>
  `alert-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

const AlertService = {
  build: (params: EnqueueParams): QueuedAlert => ({
    id: params.id ?? genId(),
    title: params.title,
    description: params.description,
    colorTheme: params.colorTheme ?? defaultColor,
    kind: params.kind ?? defaultKind,
    autoDismissDelay: params.autoDismissDelay,
  }),
  info: (
    title: string,
    description: string,
    autoDismissDelay = 2000,
    id?: string
  ): QueuedAlert =>
    AlertService.build({
      id,
      title,
      description,
      colorTheme: 'Information',
      kind: 'low',
      autoDismissDelay,
    }),
  error: (
    title: string,
    description: string,
    autoDismissDelay = 5000,
    id?: string
  ): QueuedAlert =>
    AlertService.build({
      id,
      title,
      description,
      colorTheme: 'Critical',
      kind: 'high',
      autoDismissDelay,
    }),
};

export default AlertService;
